// extracted by mini-css-extract-plugin
module.exports = {"button":"NotificationBell_button__1sqaM","count":"NotificationBell_count__3Cizo","wrapper":"NotificationBell_wrapper__otqPq"};